import React from "react";

function MusicPauseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="30"
      viewBox="0 0 28 30"
    >
      <g
        id="Group_26636"
        data-name="Group 26636"
        transform="translate(0.094 0.466)"
      >
        <g id="Group_23758" data-name="Group 23758" transform="translate(0 0)">
          <ellipse
            id="Ellipse_2005"
            data-name="Ellipse 2005"
            cx="14"
            cy="15"
            rx="14"
            ry="15"
            transform="translate(-0.094 -0.466)"
            fill="#181818"
          />
        </g>
        <path
          id="Path_18513"
          data-name="Path 18513"
          d="M6,5H8.314V18.884H6Zm6.942,0h2.314V18.884H12.942Z"
          transform="translate(3.803 2.868)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default MusicPauseIcon;
